export default __webpack_public_path__ + "static/media/Mask1.be63dec9.png";